import sharedEn from '@/lang/shared/en.json'
import en from './en.json'

// The Try Now storefront: the shared English texts without any client name or phone number
export const trialTranslations = {
  en: { ...sharedEn, ...en },
}
